


















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";

@Component
export default class UListDisplayModes extends Vue {
  // Props
  @Prop({ required: true })
  public storagePath!: UserMetaKeys;

  @Prop({ default: "is-left" })
  public tooltipPosition!: string;

  @Prop({ default: ListDisplayMode.TABLE })
  public defaultDisplayMode!: ListDisplayMode;

  @Prop({ default: () => [ListDisplayMode.TABLE, ListDisplayMode.GRID] })
  public modes!: string;

  // Data
  public displayMode: ListDisplayMode = this.modes.includes(
    this.storedDisplayMode
  )
    ? this.storedDisplayMode
    : this.$attrs?.value || this.defaultDisplayMode;

  // Getters

  public get storedDisplayMode() {
    return this.$store.getters["user/meta"](this.storagePath);
  }

  public get showDisplayModes() {
    return (this.displayModes?.length || 0) > 1;
  }

  public get displayModes() {
    return [
      {
        key: ListDisplayMode.TABLE,
        icon: "list-ul",
        type: this.displayMode === "table" ? "is-info" : "is-dark",
        label: this.$t("_.list_view"),
        select: () => {
          this.saveDisplayMode(ListDisplayMode.TABLE);
        }
      },
      {
        key: ListDisplayMode.GRID,
        icon: "th",
        type: this.displayMode === ListDisplayMode.GRID ? "is-info" : "is-dark",
        label: this.$t("_.grid_view"),
        select: () => {
          this.saveDisplayMode(ListDisplayMode.GRID);
        }
      },
      {
        key: ListDisplayMode.TREE,
        icon: "stream",
        type: this.displayMode === ListDisplayMode.TREE ? "is-info" : "is-dark",
        label: this.$t("_.tree_view"),
        select: () => {
          this.saveDisplayMode(ListDisplayMode.TREE);
        }
      },
      {
        key: ListDisplayMode.INBOX,
        icon: "columns",
        type:
          this.displayMode === ListDisplayMode.INBOX ? "is-info" : "is-dark",
        label: this.$t("_.inbox_view"),
        select: () => {
          this.saveDisplayMode(ListDisplayMode.INBOX);
        }
      }
    ].filter(i => this.modes.includes(i.key));
  }

  public saveDisplayMode(displayMode) {
    if (this.displayMode === displayMode) return;
    this.displayMode = displayMode;
    this.$store.dispatch(`user/addMeta`, {
      [this.storagePath]: displayMode
    });
  }

  @Watch("$attrs.value")
  public onValueChange() {
    this.$set(this, "displayMode", this.$attrs.value);
  }

  @Watch("displayMode", { immediate: true })
  public onDisplayModeChange() {
    this.$emit("input", this.displayMode);
  }
}
